import React from 'react'

export const EnviadoConExito = () => {
    return (
        <div className="successContainer">
            <div className="successContainer_box">
                <h1 className="successContainer_box--title">¡ENVIADO CON ÉXITO!</h1>
                <p className="successContainer_box--subtitle">A la brevedad recibirás un link para efectuar el cambio de contraseña.</p>
            </div>
        </div>
    )
}
